<template>
    <div class="sw-dropdown" ref="dropdownRef">
      <div class="sw-dropdown__title-container" @click="toggleDropdown">
        <h3 class="sw-dropdown__title">{{ name }}</h3>
        <div class="sw-dropdown--item-selected-list">
          <span
            v-for="val in selectedValues"
            :key="val"
            class="selected-badge"
          >
            {{ findLabel(val) }}
            <button @click.stop="remove(val)">×</button>
          </span>
        </div>
      </div>
  
      <div
        class="dealers-app__filters--wrapper sw-dropdown__items-container"
        v-show="open"
        @click.stop
      >
        <label
          v-for="option in options"
          :key="option.value"
          class="dealers-app__filters--checkbox sw-dropdown__items-container--item"
        >
          <input
            type="checkbox"
            :id="option.value"
            :value="option.value"
            v-model="selectedValues"
          />
          <div class="sw-input"></div>
          <span>{{ option.label }}</span>
        </label>
      </div>
    </div>
</template>

<script setup>
import { ref, watch } from 'vue';


const props = defineProps({
options: {
    type: Array,
    required: true
    },
name: {
    type: String,
    default: ''
},
modelValue: {
    type: Array,
    default: () => []
}
});

const emit = defineEmits(['update:modelValue']);

const open = ref(false);
const selectedValues = ref([...props.modelValue]);

const toggleDropdown = () => {
  open.value = !open.value;
};

const remove = (val) => {
  selectedValues.value = selectedValues.value.filter(v => v !== val);
};

const findLabel = (val) => {
  const opt = props.options.find(o => o.value === val);
  return opt ? opt.label : val;
};

// Simple click outside handler using window click
const handleGlobalClick = () => {
  open.value = false;
};

// Add/remove global click listener when dropdown opens/closes
watch(open, (isOpen) => {
  if (isOpen) {
    setTimeout(() => {
      window.addEventListener('click', handleGlobalClick, { once: true });
    }, 0);
  }
});

// Watch for changes in selectedValues and emit updates
watch(selectedValues, (newVal) => {
  emit('update:modelValue', newVal);

}, { deep: true, immediate: true });
</script>
